export default function toIterable(data) {
  return data 
}
